import { get } from '@alltrails/core/utils/get';

export type HidePoiResponse = {
  message: string;
  status: string;
};

export const hidePOI = (poiID: number) => get<HidePoiResponse>(`/admin/poi/${poiID}/set_status?status=hidden`);
